import Immutable from 'immutable';
import * as types from './constants';

const initialState = Immutable.fromJS({
  name: '',
  loading: false,
  content: null,
});

function previewReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CONTENT_REQUEST: {
      return state.set('loading', true);
    }
    case types.FETCH_CONTENT_SUCCESS: {
      return state.set('loading', false).set('content', action.payload);
    }
    case types.FETCH_CONTENT_FAILURE: {
      return state.set('loading', false);
    }
    default: {
      return state;
    }
  }
}

export default previewReducer;
